export default __webpack_public_path__ + "static/media/Chamomile-Arnica-Bottle-OK.26f3f8bf.png";